module.exports = __webpack_public_path__ + "static/media/brev.69dd4313.mp3";